import { jsx as n, jsxs as t } from "react/jsx-runtime";
import l from "react";
import { Icon as i } from "../../Icon/Icon.js";
const r = "ExcursionInfoBox-module_box__uTbFu",
  x = "ExcursionInfoBox-module_item__xK7-s",
  u = "ExcursionInfoBox-module_header__xClcj",
  d = "ExcursionInfoBox-module_custom-icon__a9Fcd",
  _ = "ExcursionInfoBox-module_label__BNbJU",
  f = "ExcursionInfoBox-module_value__5D8r4",
  I = "ExcursionInfoBox-module_content__YAYx8",
  e = {
    box: r,
    item: x,
    header: u,
    customIcon: d,
    label: _,
    value: f,
    content: I
  },
  v = _ref => {
    let {
      children: o
    } = _ref;
    return /* @__PURE__ */n("ol", {
      className: e.box,
      children: o
    });
  },
  N = _ref2 => {
    let {
      icon: o,
      label: m,
      value: a,
      children: c
    } = _ref2;
    let s = o;
    return typeof o == "string" ? s = /* @__PURE__ */n(i, {
      name: o,
      size: "1.5x",
      padding: !1
    }) : l.isValidElement(o) && (s = l.cloneElement(o, {
      className: e.customIcon
    })), /* @__PURE__ */t("li", {
      className: e.item,
      children: [/* @__PURE__ */t("div", {
        className: e.header,
        children: [s, /* @__PURE__ */n("div", {
          className: e.label,
          children: m
        }), /* @__PURE__ */n("div", {
          className: e.value,
          children: a
        })]
      }), c && /* @__PURE__ */n("div", {
        className: e.content,
        children: c
      })]
    });
  };
export { v as ExcursionInfoBox, N as ExcursionInfoBoxItem };